import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { CATEGORY_CODES } from '_constants/categories';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';
import { selectError, selectLoading, selectLoggedIn } from '_store/user/selector';
import { login, loginByToken } from '_store/user/slice';

import { ReactComponent as LogoSvg } from 'assets/images/lumen-logo-dark.svg';

import LoginForm from 'components/features/auth/LoginForm';
import Card from 'components/shared/layouts/Card';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: ${theme.spaces.regular}px;
  background-color: ${hexToRGBA(theme.colors.cyanBlue, 0.08)};
`;

const StyledInnerContainer = styled.div`
  max-width: 480px;
  width: 100%;
`;

const StyledLogoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${theme.spaces.largeX}px;
`;

const LoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const loggedIn = useSelector(selectLoggedIn);
  const error = useSelector(selectError);

  const handleSubmit = (values) => {
    if (values) {
      const { username, password } = values;
      dispatch(login({ username, password, category: CATEGORY_CODES.main }));
    }
  };

  useEffect(() => {
    const token = searchParams.get('token');
    const orderId = searchParams.get('orderId');

    if (token && !loading && !loggedIn) {
      if (!error) {
        dispatch(loginByToken({ token, orderId }));
      } else {
        navigate('.');
      }
    }
  }, [loading, loggedIn]);

  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Card>
          <StyledLogoContainer>
            <LogoSvg />
          </StyledLogoContainer>
          <LoginForm loading={loading} error={error} onSubmit={handleSubmit} />
        </Card>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default LoginPage;
